import { ActionIcon, Tooltip } from '@mantine/core';
import { PanelLeftClose, PanelRightClose } from 'lucide-react';
import { FC } from 'react';

import useBreakpoints from '@/hooks/useBreakpoints.ts';

import { TaskModalMode } from '@/models/TaskModalMode.ts';

import { useTaskViewStore } from '@/stores/taskViewStore.ts';

const TaskListCta: FC = () => {
    const show_task_list = useTaskViewStore((state) => state.show_task_list);
    const task_modal_mode = useTaskViewStore((state) => state.task_modal_mode);
    const { is_less_than_xl } = useBreakpoints();

    if (is_less_than_xl) return undefined;

    return (
        <Tooltip label={show_task_list ? 'Aufgabenliste ausblenden' : 'Aufgabenliste anzeigen'}>
            <ActionIcon
                variant="transparent"
                onClick={() => useTaskViewStore.setState({ show_task_list: !show_task_list })}
                disabled={task_modal_mode === TaskModalMode.EDITOR}
            >
                {show_task_list ? (
                    <PanelRightClose className="text-black" />
                ) : (
                    <PanelLeftClose className="text-black" />
                )}
            </ActionIcon>
        </Tooltip>
    );
};

export default TaskListCta;
